webpackJsonp([110],{

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".MailContactImage1-a{display:block;margin:0 auto}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/MailContactImage1/src/components/contents/MailContactImage1/MailContactImage1.s.scss"],"names":[],"mappings":"AAGE,qBACE,cAAc,AACd,aAAc,CACf","file":"MailContactImage1.scss","sourcesContent":["@import '~scss/variables';\n\n.MailContactImage1 {\n  &-a {\n    display: block;\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("28df7f71", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/110.ce095c407e712bd59a8e.js